import React from "react";
import { WebhooksScreen } from "~/screens/admin/webhooks";

export const WebhooksTab: React.FC = () => {
  return <WebhooksScreen />;
};

export default WebhooksTab;
